//import Libraries
import React from 'react';
import PropTypes from 'prop-types'

//import Styles
import './MyInfo.css'

const mypageButton = ({value, onClick}) => {

    return (
        <div className="Element">
            <button onClick={onClick}>{value}</button>
        </div>
    );
}

export default mypageButton;


// WEBPACK FOOTER //
// ./src/pages/MyPage/MyPageButton.js